var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "finacial-flow-chart-view2-multi-currency" },
    [
      _c(
        "div",
        {
          staticClass: "section operations",
          staticStyle: { "margin-bottom": "2px" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { "margin-bottom": "-12px" },
              attrs: { inline: "" }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_AccountTitle") } },
                [
                  _c(
                    "el-select",
                    {
                      ref: "accountTitleRef",
                      staticStyle: { width: "300px" },
                      attrs: { filterable: true, clearable: true, no: "1" },
                      model: {
                        value: _vm.form.accountTitle,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "accountTitle", $$v)
                        },
                        expression: "form.accountTitle"
                      }
                    },
                    _vm._l(_vm.accountTitleCollection, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.accountTitleLabelFun(item),
                          value: item.uuid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.AccountingDate") } },
                [
                  _c("el-date-picker", {
                    ref: "documentDateRef",
                    staticStyle: { width: "128px" },
                    attrs: {
                      format: "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                      "default-value": _vm.defaultDate,
                      no: "2"
                    },
                    model: {
                      value: _vm.form.documentDate,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "documentDate", $$v)
                      },
                      expression: "form.documentDate"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Currency") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100px" },
                      attrs: { no: "3" },
                      model: {
                        value: _vm.form.currency,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "currency", $$v)
                        },
                        expression: "form.currency"
                      }
                    },
                    _vm._l(_vm.usedCurrencyCollection, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Abstract") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { no: "4" },
                    model: {
                      value: _vm.form.summaryText,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "summaryText", $$v)
                      },
                      expression: "form.summaryText"
                    }
                  })
                ],
                1
              ),
              _c("br"),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Customer") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      "callback-params": { key: "customer" },
                      "default-value": _vm.form.customer,
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "callback-method-type": "value",
                      filterable: "",
                      no: "5"
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Department") } },
                [
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    staticStyle: { width: "120px" },
                    attrs: {
                      "callback-params": { key: "departmentId" },
                      "default-value": _vm.form.departmentId,
                      "select-type": _vm.selectTypeNames.basic_data_Department,
                      "method-params": {
                        officeUuid: _vm.$store.getters.currentOfficeUuid
                      },
                      "callback-method-type": "value",
                      filterable: "",
                      no: "6"
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  }),
                  _c("office-department-cascader", {
                    staticStyle: { width: "298px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip"),
                      no: "7"
                    },
                    model: {
                      value: _vm.form.departmentIds,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "departmentIds", $$v)
                      },
                      expression: "form.departmentIds"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_Sales") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "140px" },
                    attrs: {
                      "callback-params": { key: "sales" },
                      "default-value": _vm.form.sales,
                      "select-type": _vm.selectTypeNames.basic_data_User,
                      "callback-method-type": "value",
                      filterable: "",
                      no: "8"
                    },
                    on: { parentCallBack: _vm.selectChangeHandler }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-checkbox", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ShowDetailedTitles"),
                      no: "9"
                    },
                    model: {
                      value: _vm.form.showItems,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showItems", $$v)
                      },
                      expression: "form.showItems"
                    }
                  }),
                  _c("el-checkbox", {
                    attrs: {
                      label: _vm.$t("CargoMsg.Cargo_ShowAdjustRateEntry"),
                      no: "10"
                    },
                    model: {
                      value: _vm.form.showAdjustRateEntry,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "showAdjustRateEntry", $$v)
                      },
                      expression: "form.showAdjustRateEntry"
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticClass: "el-margin",
                      staticStyle: { "margin-left": "20px" },
                      attrs: { type: "primary", no: "11" },
                      on: { click: _vm.doSearch }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "section", staticStyle: { flex: "1", padding: "0px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "800px" },
            attrs: {
              "show-side-bar": false,
              "column-defs": _vm.columnDefs,
              "grid-options": _vm.gridOptions,
              "grid-params": _vm.girdParams,
              "row-data": _vm.rowData,
              "auto-fit-content": false,
              no: "12"
            },
            on: {
              "update:gridParams": function($event) {
                _vm.girdParams = $event
              },
              "update:grid-params": function($event) {
                _vm.girdParams = $event
              }
            }
          })
        ],
        1
      ),
      _vm.accountingEntryWindow.visible
        ? _c("accounting-entry-window", {
            attrs: {
              "account-set": _vm.accountSet,
              "account-title-data-provider":
                _vm.accountingEntryWindow.accountTitleDataProvider,
              index: _vm.accountingEntryWindow.index,
              "is-ext": _vm.isExt,
              "mapping-departments": _vm.mappingDepartments,
              "mapping-staffs": _vm.mappingStaffs,
              "prefix-data-provider": _vm.accountingDocumentTypes,
              visible: _vm.accountingEntryWindow.visible,
              voucher: _vm.accountingEntryWindow.voucher,
              no: "13"
            },
            on: {
              close: function() {
                return (_vm.accountingEntryWindow.visible = false)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }